/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORM : FIELD : RADIO : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	radio: {
		// background: `#FAFBFC`,
		// borderRadius: pxToEm(4),
		// border: replacePXinStringWithEM(`2px solid #EEF2F6`),
		// transform: 'scale(1.2)',
		marginLeft: pxToEm(8),
		marginRight: pxToEm(17),
		// height: pxToEm(24),
		// width: pxToEm(24)
	}
});